import { SIDE_MENU_LOADED, SIDE_MENU_LOADING, UPDATE_MENU_FILTER } from '../actions/sideMenuAction';
import addParentMenu from '../utils/addParentMenu';
import { removeMenuById, pruneEmptySubMenus } from '../utils/removeMenuByID/removeMenuByID';

export const initState = () => ({
  sideMenuLoading: false,
  sideMenu: null,
  rawSideMenu: null, // Store original unfiltered data
  menuFilters: {}, // Track active filters: { ispm: false, pam: false }
});

export const appReducer = () => (state = initState(), action) => {
  switch (action.type) {
    case SIDE_MENU_LOADING:
      return { ...state, sideMenuLoading: true };

    case SIDE_MENU_LOADED:
      const processedData = addParentMenu(action.data);
      return { 
        ...state, 
        sideMenuLoading: false, 
        sideMenu: processedData, 
        rawSideMenu: state.rawSideMenu || processedData // Only set once 
      };

    case UPDATE_MENU_FILTER:
      if (!state.rawSideMenu?.length || !action.menuId) {
        return state;
      }
      
      const newFilters = { ...state.menuFilters, [action.menuId]: action.isEnabled };
      const filteredMenu = pruneEmptySubMenus(
        Object.entries(newFilters).reduce((menu, [menuId, enabled]) => {
          return enabled || !menu ? menu : removeMenuById(menu, menuId);
        }, state.rawSideMenu)
      );

      return {
        ...state,
        menuFilters: newFilters,
        sideMenu: filteredMenu || state.rawSideMenu
      };

    default:
      return state;
  }
};

export default appReducer();
